import { Component, OnInit } from '@angular/core';
import 'hammerjs';
import { NguCarousel } from '@ngu/carousel';
import {TranslationsService} from '../services/translations.service';
import {AboutService} from '../services/about.service';
import {Config} from '../config';
import {BuildingService} from '../services/building.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  public carouselTile: NguCarousel;
  words: any;
  lang: any;
  book: any;
  error: any;
  buildings: any;
  public backendUrl: any = new Config();
  backgroundImages: any;
  constructor(private translationsService: TranslationsService,
              private buildingService: BuildingService,
              private aboutService: AboutService) {
    this.translationsService.langName$.subscribe((res) => {
      this.lang = res;
    });
  }

  ngOnInit() {
    this.error = [false, false, false, false, false];
    this.book = {
      start: '',
      end: '',
      rooms: '',
      adult: '',
      child: '',
      email: '',
      fullName: '',
      phone: '',
      buildingId: '',
      roomId: '',
      high: 0,
      low: 0,
      sum: 0
    };
    if (localStorage.getItem('bookData')) {
      this.book = JSON.parse(localStorage.getItem('bookData'));
    }
    this.lang = localStorage.getItem('lang');
    this.translationsService.getTranslations().subscribe(resp => {
      if (!resp.error) {
        this.words = resp.data[0];
      }
    });
    this.buildingService.getBuildings().subscribe( res => {
      if (!res.error) {
        this.buildings = res.data;
      }
    });
    this.backgroundImages = [];
    this.aboutService.getSliderImages().subscribe( res => {
      if (!res.error) {
        this.backgroundImages = res.data;
      }
    });
    this.carouselTile = {
      grid: {xs: 1, sm: 1, md: 1, lg: 1, all: 0},
      slide: 1,
      speed: 400,
      interval: 4000,
      point: {
        visible: true
      },
      load: 2,
      touch: true,
      loop: true,
      custom: 'banner'
    }
  }

  bookNow() {
    this.error = [false, false, false, false, false];
    if (this.book.start) {
      if (new Date(this.book.start).toISOString() < new Date().toISOString().split('T')[0]) {
        this.error[0] = true;
      }else {
        this.error[0] = false;
        if (this.book.end) {
          if (new Date(this.book.end).toISOString() < new Date().toISOString().split('T')[0]) {
            this.error[1] = true;
          }else {
            if (new Date(this.book.start) <= new Date(this.book.end)) {
              this.error[0] = false;
              this.error[1] = false;
            }else {
              this.error[0] = true;
              this.error[1] = true;
            }
          }
        }else {
          this.error[1] = true;
        }
      }
    }else {
      this.error[0] = true;
      if (this.book.end) {
        if (new Date(this.book.end).toISOString() < new Date().toISOString().split('T')[0]) {
          this.error[1] = true;
        }else {
          this.error[1] = false;
          if (new Date(this.book.start) <= new Date(this.book.end)) {
            this.error[0] = false;
            this.error[1] = false;
          }else {
            this.error[0] = true;
          }
        }
      }else {
        this.error[1] = true;
      }
    }

    if (this.book.rooms) {
      this.error[2] = false;
    }else {
      this.error[2] = true;
    }
    if (this.book.adult) {
      this.error[3] = false;
    }else {
      this.error[3] = true;
    }
    if (this.book.child) {
      this.error[4] = false;
    }else {
      this.error[4] = true;
    }
    if (this.error.indexOf(true) >= 0) {
      window.scroll(0, 0);
      return false;
    }else {
      localStorage.setItem('bookData', JSON.stringify(this.book));
      window.location.pathname = '/room/' + this.buildings[0]._id + '/all';
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/home/home.component.ts